import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { Container, Col, Row } from "react-bootstrap";

import NavbarComponent from '../components/NavbarComponent';
import FooterComponent from '../components/FooterComponent';

import I18N from "../js/i18n";

var jwt = require("jsonwebtoken");

var METABASE_SITE_URL = "https://bi.agorahub.xyz";
var METABASE_SECRET_KEY = "02a228b915cfb435c6dbd1d7974e779aca29b28d215ed686f3ac14c4623aff0b";

class Home extends React.Component {
    
    render() {

        var payload = {
            resource: { dashboard: 3 },
            params: {
              "supplier": this.props.auth.supplierId
            },
            exp: Math.round(Date.now() / 1000) + (10 * 60) // 10 minute expiration
          };
          var token = jwt.sign(payload, METABASE_SECRET_KEY);
          
          var iframeUrl = METABASE_SITE_URL + "/embed/dashboard/" + token + "#bordered=false&titled=true";

        return (
            <>
            <Container fluid className="p-0">
                <NavbarComponent />
                <Container>
                    <Row>
                        <Col xs={12}>
                            <iframe
                                src={iframeUrl}
                                frameBorder="0"
                                width="100%"
                                height="1280"
                                allowtransparency="true"
                            ></iframe>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <FooterComponent />
            </>
        )
    }

}

const mapStateToProps = state => {
    const {auth} = state;
    return { auth: auth };
};

export default connect(mapStateToProps, null)(withRouter(Home));